const siteConfig = {
  name: 'Uzdpart360',
  owner: 'Uzdpart',
  description: 'End-to-end business operations platform for Uzdpart',
  version: '6.3.0',
  // Increment build_no with every deployment.
  // Socket events with a build_no <= this value are silently ignored.
  build_no: 12092257,
};

export default siteConfig;
